module.exports = __webpack_public_path__ + "static/img/newHuaiC1.648d8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC1.png
// module id = KYxp
// module chunks = 0